import { environment } from '@mg-platform/core/core-util'

export const TARGETS_API_URL = {
  targetsBase: (shopId: string) => `${environment.apiUrl}/goals/${shopId}`,
  getForecast: `${environment.apiUrl}/goals/forecast`,
  updateForecast: `${environment.apiUrl}/goals/forecast-update`,
  getHistory: `${environment.apiUrl}/goals/history`
}
